import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";


export class action_AP_RefreshRepository extends Component implements IActionBase {
    actionCode = "action_AP_RefreshRepository";
    actionName = "Refresh Repository";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        let params = {
            prmProjectID: store.getState().store_ProjectData.projectID,
            prmDeveloperKey: "ServerAction_RefreshList",
            prmParamsDic: {
                ListNames: prmActionParameters?.ListNames,
            }
        };

        callPostService("Asset_ExecuteServerAction", params).then((prmResponse: webResponseObject) => {
            if (!!prmResponse?.reponseObj?.IsValid && prmResponse?.reponseObj?.IsValid == "true") {
                utils_ui.showToaster(utils_ui.getLanguageTitle('Message_JobCompletedSucessfully'), 'succeed')
            }
            else if (prmResponse?.reponseObj?.IsValid == "false") {
                utils_ui.showToaster(utils_ui.getLanguageTitle('Message_JobFailed'), 'error')
            }

            //prmCallbackFunction(lstFavoriteTasks);

        })
    }

}